import { CONTENT_API_CONFIG } from './content-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { buildUrl } from '@wizbii-utils/angular/core';
import { AdviceArticleFacade } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

export interface ParamsContentApi {
  categories?: string[];
  offset?: string;
  rows?: string;
}

@Injectable()
export class ContentAdvicesApiWebservice {
  readonly #http = inject(HttpClient);
  readonly #contentApiConfig = inject(CONTENT_API_CONFIG);

  readonly #baseUrl = this.#contentApiConfig.baseUrl;
  readonly #blogId = this.#contentApiConfig.blogId;

  getArticles<T = AdviceArticleFacade[]>(parameters?: ParamsContentApi): Observable<T> {
    const urlBuilding = buildUrl(`${this.#baseUrl}/v2/facades/${this.#blogId}`, {
      categories: parameters?.categories?.join(),
      offset: parameters?.offset,
      rows: parameters?.offset,
    });
    return this.#http.get<T>(urlBuilding);
  }

  getRecommendedArticles<T = AdviceArticleFacade[]>(articleSlug: string): Observable<T> {
    return this.#http.get<T>(`${this.#baseUrl}/v1/facades/${this.#blogId}/recommended/${articleSlug}`);
  }

  getArticlesById<T = AdviceArticleFacade>(articleId: string): Observable<T> {
    return this.#http.get<T>(`${this.#baseUrl}/v1/facade/${this.#blogId}-${articleId}`);
  }
}
